<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col sm="12">
        <b-card header-tag="header" footer-tag="footer">
          <div slot="header">
            <strong> Manual MPS Status Update Activity Log</strong>
          </div>
          <div id="listloader" v-if="loader">
            <div class="listloader"></div>
          </div>
          <b-row class="align-items-center pl-2">

            <b-col sm="4">
              <b-col sm="12">
                <b-form-group label="From Date:" :label-cols="4">
                  <v-date-picker mode='single' input-class="dateInput"
                    :available-dates='{ start: null, end: new Date() }' v-model='selectDateFrom'>
                  </v-date-picker>
                </b-form-group>
              </b-col>
            </b-col>

            <b-col sm="4">
              <b-form-group label="To Date:" :label-cols="4">
                <v-date-picker mode='single' input-class="dateInput" :available-dates='{ start: null, end: new Date() }'
                  v-model='selectDateTo'>
                </v-date-picker>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="align-items-center m-2">

            <b-col>
              <b-form-group label="Select Hub" :label-cols="2">
                <b-form-select v-model="selectedhub">
                  <option :value="select">-- Select Hub --</option>
                  <option :value="hub.hubid" v-for="hub in hubItems" :key="hub.hubid">
                    {{ hub.hubname }} - {{ hub.hubid }}
                  </option>

                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col sm="5" style="margin-top:-19px; text-align: right;">
              <b-button variant="info" @click="searchData();">
                Search
              </b-button>

              <b-button variant="danger" class="ml-2" @click="clearData">
                Clear
              </b-button>
              <b-button :disabled="this.items.length == 0" variant="success" class="ml-2" @click="downloaddata()">
                Download
              </b-button>
              <!--<b-button class="ml-1" variant="secondary" @click="goback()"> Back
              </b-button>-->

            </b-col>

          </b-row>

          <!-- TOP RIGHT RECORD COUNT -->
        <div class="text-right mb-1 total-records" style="font-weight: 600;">
            Total Records : <span class="count text-danger" >{{ totalRows }}</span>
        </div>

          <b-row class="mt-4">
            <b-col sm="12">
              <b-table show-empty responsive :busy="isBusy" :items="items" :fields="fields" :current-page="currentPage"
                :bordered="bordered" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
                <!-- @filtered="onFiltered"
                    :filter="filter" -->
                <div slot="table-busy" class="text-center text-danger my-2">
                  <b-spinner class="align-middle"></b-spinner>
                  <strong>Loading...</strong>
                </div>
                <template slot="srno" slot-scope="row">
                  {{ ((pageNum - 1) * perPage) + row.index + 1 }}
                </template>

                <template slot="statusupdatedfrom" slot-scope="row">
                  <p>HubInScan</p>

                </template>
                <template slot="statusupdatedto" slot-scope="row">
                  <p>InTransit</p>
                </template>

                <template slot="hubtitle" slot-scope="row" v-if="row.item.hub_id">
                  {{ row.item.hub_title }}<br />
                  <span style="color:blue">HubID-{{ row.item.hub_id }}</span>
                </template>

               <template slot="remarks" slot-scope="row">
    <b-form-textarea
        :value="row.item.remarks"
        rows="3"
        readonly
        no-resize
        style="min-width:250px;"
    >
    </b-form-textarea>
</template>


              </b-table>
            </b-col>

            <b-col md="12" class=" " v-if="totalRows && totalRows.length > 0">
              <paginate v-model="pageNum" :page-count="noofpages" :page-range="10" :margin-pages="2"
                :click-handler="clickCallback" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"
                :page-class="'page-item'">
              </paginate>
            </b-col>
          </b-row>

        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import CONSTANTS from "@/utils/constants";
import Utils from "@/utils";

export default {
  data: function () {
    return {
      awbNo: '',
      items: [],
      fields: [
        { key: 'srno', label: 'Request Number' },
        {
          key: "shippingid", label: 'MPS Number',
          tdClass: 'text-nowrap'
        },
        {
          key: "parentawb", label: 'AWB Number',
          tdClass: 'text-nowrap'
        },
        {
          key: "old_status", label: 'Status Updated From',
          tdClass: 'text-nowrap'
        },
        {
          key: "new_status", label: 'Status Updated To',
          tdClass: 'text-nowrap'
        },
        {
          key: "updatedby", label: 'Status Updated By',
          tdClass: 'text-nowrap', formatter: value => value || 'NA',
        },

        {
          key: "lastmodifiedbyid", label: 'Status Updated By User ID',
          tdClass: 'text-nowrap', formatter: value => value || 'NA',
        },

        {
          key: "updatedon",
          label: "Status Updated On",
          formatter: value => {
            if (!value) return "NA";

            const date = new Date(value);

            return date.toLocaleString("en-GB", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true
            });
          },
          tdClass: "text-nowrap"
        },

        {
          key: "hub_title", label: 'Hub Name',
          tdClass: 'text-nowrap'
        },

        {
          key: "remarks", label: 'Remarks',
          tdClass: 'text-nowrap'
        },

      ],
      selectedMpsIds: [],
      selectAll: false,
      selectedStatus: null,

      selectDateFrom: new Date(),
      selectDateTo: new Date(),
      hubItems: [],
      selectedhub: '',
      select: '',
      fromatstartdate: '',
      formatenddateto: '',
      loader: false,
      pageNum: 1,
      noofpages: '',
      totalRows: 0,
      currentPage: 1,
      pageOptions: [5, 10, 15],
      perPage:  20,
    };
  },

  created: function () {
    this.hubListing();
  },

  methods: {

    goback() {
        this.$router.push({
            path: '/manualmpsstatusupdate'
        });
    },
    clickCallback(pageNum) {
      this.searchData(pageNum);
    },

    hubListing() {
      var userdata = localStorage.getItem("userData");
      var userInfo = JSON.parse(userdata);
      const obj = {
        sysusermasterid: `${userInfo.sysusermasterid}`,
        usertype: `${userInfo.user_type}`,
      }
      console.log("objlist", obj)
      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/getAllHubListing`, obj).then(result => {
            if (result.body.returnmsg === "Successful") {
              this.hubItems = result.body.returnvalue;
              console.log("aaaaaaaa", this.hubItems);

            } else {
              this.hubItems = [];
            }
          }).catch(ex => {
            console.log("error", ex);
          });
    },


    searchData: function (pageNum) {
      this.loader = true;
      var starttoday = this.selectDateFrom;
      // Current Date
      this.fromatstartdate = starttoday.getFullYear() + '-' + (starttoday.getMonth() + 1) + '-' + starttoday.getDate();
      console.log("startdate", this.fromatstartdate);

      var endtoday = this.selectDateTo;
      // End Date
      this.formatenddateto = endtoday.getFullYear() + '-' + (endtoday.getMonth() + 1) + '-' + endtoday.getDate();

      if (this.selectDateTo < this.selectDateFrom) {
        this.$fire({
          text: "From Date must be less than To Date ",
          type: "warning",
          timer: 3000,
        });
        this.loader = false;
        return;
      }

      const obj = {
        selectDateFrom: this.fromatstartdate,
        selectDateTo: this.formatenddateto,
        selectedhub: this.selectedhub,
        page_no: pageNum ? pageNum : this.pageNum
      };

      this.$http.post(
        `${CONSTANTS.MIGRATION_API_URL}/getMpasAndAwbdetailsdata`,
        obj
      )
        .then(result => {
          this.loader = false;
          if (result.body.returnmsg === "successful") {

            this.items = result.body.returnvalue;
            this.totalRows = result.body.returnvalue[0].totalcount
            console.log("this.totalRows", this.totalRows);
            
            this.noofpages = Math.ceil(this.totalRows / this.perPage);

          } else {

            this.items = [];
            his.totalRows =0
            this.noofpages =0
          }
        });
    },

    clearData() {

      this.items = [];
      this.totalRows=0;
      this.selectedMpsIds = [];
      this.selectDateTo = new Date()
      this.selectDateFrom = new Date()
      this.selectedhub = ''
    },

    downloaddata() {

      const obj = {
        selectDateFrom: this.fromatstartdate,
        selectDateTo: this.formatenddateto,
        selectedhub: this.selectedhub
      };

      this.loader = true;

      this.$http
        .post(
          `${CONSTANTS.MIGRATION_API_URL}/getMpasAndAwbdetailsdata`, obj
        )
        .then((result) => {

          const data = result.data.returnvalue;

          const headers = [
            { key: 'shippingid', label: 'MPS Number' },
            { key: 'parentawb', label: 'AWB Number' },
            { key: 'old_status', label: 'Status Updated From' },
            { key: 'new_status', label: 'Status Updated To' },
            { key: 'updatedby', label: 'Status Updated By' },
            { key: 'lastmodifiedbyid', label: 'Status Updated By User ID' },
            { key: 'updatedon', label: 'Status Updated On' },
            { key: 'hub_title', label: 'Hub Name' },
            { key: 'remarks', label: 'Remark' }
          ];

          const csvRows = [];

          // Header row
          csvRows.push(headers.map(h => h.label).join(','));

          // Data rows
          data.forEach(row => {
            csvRows.push(
              headers.map(h => {
                let value = row[h.key];

                // Format date
                if (h.key === 'lastmodifiedon' && value) {
                  value = new Date(value).toLocaleString('en-IN');
                  // Example: 04/06/2026, 06:17:45 am
                }

                return `"${value != null ? value : ''}"`;
              }).join(',')
            );
          });

          const csvContent = csvRows.join('\n');

          const blob = new Blob([csvContent], {
            type: 'text/csv;charset=utf-8;'
          });

          const link = document.createElement('a');

          link.href = URL.createObjectURL(blob);
          link.download = 'MPS_Updated_status.csv';

          document.body.appendChild(link);
          link.click();
          link.remove();

          this.loader = false;
        })
        .catch((error) => {

          console.log(error);

          this.loader = false;

        });

    }
  }


};
</script>
<style>
.remarks-wrap{
    white-space: normal !important;
    word-break: break-word;
    overflow-wrap: break-word;
    max-width: 300px;
}
</style>